exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerWrap_2NX1h {\n    font-size: 16px;\n}\n\n.footerWrap_2NX1h p {\n    margin: 0;\n}\n\n.footerDescription_2AB86 {\n    font-style: italic;\n    margin-right: 50px;\n}\n\n.footerLeft_1IF-m {\n    width: 75%;\n    display: inline-block;\n    font-size: 12px;\n}\n\n.footerRight_2T8Pq {\n    width: 25%;\n    display: inline-block;\n    text-align: right;\n    font-size: 12px;\n}\n\n.footerBold_2sJNM {\n    font-weight: bold;\n    /* padding-left: 3px; */\n    font-size: 13px;\n}\n", ""]);

// exports
exports.locals = {
	"footerWrap": "footerWrap_2NX1h",
	"footerDescription": "footerDescription_2AB86",
	"footerLeft": "footerLeft_1IF-m",
	"footerRight": "footerRight_2T8Pq",
	"footerBold": "footerBold_2sJNM"
};